import { useEffect, useState } from 'react'

export function useMobile() {
  const [isMobile, setIsMobile] = useState(true)
  const [isTablet, setIsTablet] = useState(false)

  useEffect(() => {
    function resize() {
      setIsTablet(window.innerWidth < 1024)
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', resize)
    resize()

    return () => {
      window.removeEventListener('resize', resize)
    }
  }, [])

  return {
    isMobile,
    isTablet,
  }
}
